import config from 'config'
import {
  authHeader,
  authHeaderAuthenticate,
  authHeaderSSOLogin
} from '../_helpers'
import moment from 'moment'
import md5 from 'md5'
import * as Msal from 'msal'

const userService = {
  login,
  SSOlogin,
  logout,
  register,
  insert,
  getAll,
  getById,
  update,
  refresh,
  delete: _delete
}

export default userService

function login(UserAD, Password) {
  const jsondata = {
    UserAD: UserAD,
    Password: md5(Password)
  }

  const requestOptions = {
    method: 'POST',
    headers: authHeaderAuthenticate(),
    body: JSON.stringify(jsondata)
  }

  return fetch(`${config.apiUrl}/authenticate`, requestOptions)
    .then(handleResponse)
    .then(user => {
      var responseJson = { status: 'fail' }

      if (user) {
        responseJson = {
          id: user.UserId,
          username: user.UserName,
          firstName: user.FirstName,
          lastName: user.LastName,
          departmentId: user.DepartmentId,
          departmentLocate: user.DepartmentLocate,
          avatarUrl: user.AvatarUrl,
          authorizationToken: user.AuthorizationToken,
          loginDateTime: moment(new Date()),
          isAdmin: user.IsAdmin,
          status: 'success'
        }

        localStorage.setItem('user', JSON.stringify(responseJson))
      } else {
        localStorage.removeItem('user')
      }

      return responseJson
    })
}

function SSOlogin(UserData) {
  const requestOptions = {
    method: 'POST',
    headers: authHeaderSSOLogin(UserData.AuthorizationToken),
    body: JSON.stringify(UserData)
  }

  return fetch(`${config.apiUrl}/ssologin`, requestOptions)
    .then(handleResponse)
    .then(user => {
      var responseJson = { status: 'fail' }

      if (user) {
        responseJson = {
          id: user.UserId,
          username: user.UserName,
          firstName: user.FirstName,
          lastName: user.LastName,
          departmentId: user.DepartmentId,
          departmentLocate: user.DepartmentLocate,
          avatarUrl: user.AvatarUrl,
          authorizationToken: user.AuthorizationToken,
          loginDateTime: moment(new Date()),
          isAdmin: user.IsAdmin,
          status: 'success'
        }

        localStorage.setItem('user', JSON.stringify(responseJson))
      } else {
        localStorage.removeItem('user')
      }

      return responseJson
    })
}

function refresh(username) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(`${config.apiUrl}/users/` + username, requestOptions)
    .then(handleResponse)
    .then(user => {
      var responseJson = { status: 'fail' }

      //user not found
      if (user.length === 0) {
        localStorage.removeItem('user')
      } else {
        const data = user.find(function (item) {
          return item.UserId === username
        })

        responseJson = {
          id: data.UserId,
          username: data.UserName,
          firstName: data.FirstName,
          lastName: data.LastName,
          departmentId: data.DepartmentId,
          departmentLocate: user.DepartmentLocate,
          avatarUrl: data.AvatarUrl,
          authorizationToken: user.AuthorizationToken,
          loginDateTime: moment(new Date()),
          isAdmin: data.IsAdmin,
          status: 'success'
        }

        localStorage.setItem('user', JSON.stringify(responseJson))
      }

      return responseJson
    })
}

function logout() {
  const useritem = JSON.parse(localStorage.getItem('user'))

  if (useritem) {
    const logger = {
      UserId: useritem.id,
      LogType: 'LOGOUT',
      LogStatus: 'S',
      LoginToken: useritem.authorizationToken
    }
    loginLogger(logger)
  }

  // remove user from local storage to log user out
  localStorage.removeItem('user')
  // var msalConfig = {
  //   auth: {
  //     clientId: config.clientId,
  //     authority: config.authorityUrl,
  //     postLogoutRedirectUri: config.loginUrl
  //   },
  //   cache: {
  //     cacheLocation: 'localStorage',
  //     storeAuthStateInCookie: true
  //   }
  // }
  // var myMSALObj = new Msal.UserAgentApplication(msalConfig)
  // myMSALObj.logout()
  window.location.replace(config.loginUrl)
}

function getAll() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(`${config.apiUrl}/users`, requestOptions).then(handleResponse)
}

function getById(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(`${config.apiUrl}/users/${id}`, requestOptions).then(
    handleResponse
  )
}

function loginLogger(logger) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(logger)
  }

  return fetch(`${config.apiUrl}/logger`, requestOptions).then(handleResponse)
}

function register(user) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(user)
  }

  return fetch(`${config.apiUrl}/users/register`, requestOptions).then(
    handleResponse
  )
}

function insert(user) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(user)
  }

  return fetch(`${config.apiUrl}/users`, requestOptions).then(handleResponse)
}

function update(user) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader() },
    body: JSON.stringify(user)
  }

  return fetch(`${config.apiUrl}/users`, requestOptions).then(handleResponse)
}

function _delete(user) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader(),
    body: JSON.stringify(user)
  }

  return fetch(`${config.apiUrl}/users`, requestOptions).then(handleResponse)
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout()
        //location.reload(true);
      }

      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }

    return data
  })
}



// WEBPACK FOOTER //
// ./src/_services/user.service.js